export default function AdoptionProcess() {
  const steps = [
    {
      number: '1',
      title: 'View Our Available Kittens',
      description: 'Explore the current litter and choose the kitten you love.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '2',
      title: 'Contact Us',
      description: 'Confirm availability and ask any questions.',
      icon: 'ri-message-3-line'
    },
    {
      number: '3',
      title: 'Receive Kitten Details',
      description: 'Health record, vet documents, feeding routine, and personality notes.',
      icon: 'ri-file-text-line'
    },
    {
      number: '4',
      title: 'Reserve Your Kitten',
      description: 'Secure your kitten with a small deposit.',
      icon: 'ri-bookmark-line'
    },
    {
      number: '5',
      title: 'Pick-Up or Meet-Up',
      description: 'Arrange a safe transition of your new Ragdoll to your home.',
      icon: 'ri-home-heart-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">How the Adoption Process Works</h2>
          <p className="text-xl text-gray-600">Simple, transparent steps to bring your Ragdoll kitten home</p>
        </div>

        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex items-start mb-12">
                <div className="flex-shrink-0 mr-8">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-purple-300 rounded-full flex items-center justify-center shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                </div>
                <div className="flex-grow bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
                  <div className="flex items-center mb-3">
                    <span className="text-5xl font-bold text-blue-400 mr-4">{step.number}</span>
                    <h3 className="text-2xl font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <p className="text-lg text-gray-700 leading-relaxed ml-16">{step.description}</p>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="absolute left-10 top-20 w-0.5 h-12 bg-gradient-to-b from-blue-400 to-purple-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
